import React from 'react';

const SubscriptionIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.5 3.75C1.25736 3.75 0.25 4.75736 0.25 6V6.875H19.75V6C19.75 4.75736 18.7426 3.75 17.5 3.75H2.5Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.75 9.375H0.25V14C0.25 15.2426 1.25736 16.25 2.5 16.25H17.5C18.7426 16.25 19.75 15.2426 19.75 14V9.375ZM3.125 12.1875C3.125 11.6697 3.54473 11.25 4.0625 11.25H7.1875C7.70527 11.25 8.125 11.6697 8.125 12.1875C8.125 12.7053 7.70527 13.125 7.1875 13.125H4.0625C3.54473 13.125 3.125 12.7053 3.125 12.1875Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default SubscriptionIcon;
